export default __webpack_public_path__ + "static/media/home.9c74dc4d.gif";